export default __webpack_public_path__ + "static/media/CLIENTE_9.0e51d98c.png";